export default __webpack_public_path__ + "static/54171-27227d06a5608221a1211088b91e2bb6.jpg";